/** Picks the health backend: mock (default) or `/api/v1/health*` (same origin/session as ../index.ts). */
import { useMock } from '../index'
import { HttpHealthApi } from './http'
import { MockHealthApi } from './mock'
import type { HealthApi } from './types'

let current: HealthApi | null = null

export function getHealthApi(): HealthApi {
  if (!current) {
    const base = (import.meta.env.VITE_API_BASE ?? '').trim()
    current = useMock ? new MockHealthApi() : new HttpHealthApi(base)
  }
  return current
}

/** Tests inject their own backend. */
export function setHealthApi(api: HealthApi | null): void {
  current = api
}

export { HealthRateLimited } from './errors'
export type * from './types'
